import { createAsyncThunk, EntityId } from '@reduxjs/toolkit';

interface PlanningQuery {
	_delete(ids: EntityId[]): Promise<EntityId[]>;
}

export const deletePlanning = createAsyncThunk('[PLANNING] deletePlanning', async (ids: EntityId[], thunkAPI) => {
	return await (thunkAPI.extra as { planningService: PlanningQuery }).planningService._delete(ids);
});
